import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import PublicSite from "@/pages/PublicSite";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Parents from "@/pages/Parents";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import StemLibrary from "@/pages/StemLibrary";
import AdminLibrary from "@/pages/AdminLibrary";
import Canonical from "@/components/Canonical";
import "@/App.css";

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-icdh-navy" />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/parents" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll />
            <Canonical />
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<PublicSite />} />
              <Route path="/stem" element={<StemLibrary />} />
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<Protected adminOnly><AdminDashboard /></Protected>} />
              <Route path="/admin/library" element={<Protected adminOnly><AdminLibrary /></Protected>} />
              <Route path="/parents" element={<Protected><Parents /></Protected>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
